import './App.svelte.css';
/* src/App.svelte generated by Svelte v3.43.1 */
import {
	SvelteComponent,
	add_flush_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import Stack from './components/stack.svelte.js';
import Heap from './components/heap.svelte.js';
import OpcodeSet from './components/opcode-set.svelte.js';
import Program from './components/prog.svelte.js';
import { instructionSet } from './lib/instruction-set.js';

function create_fragment(ctx) {
	let div3;
	let program;
	let updating_prog;
	let t0;
	let button0;
	let t2;
	let button1;
	let t3;
	let t4;
	let div2;
	let div0;
	let stack_1;
	let t5;
	let div1;
	let heap_1;
	let t6;
	let br;
	let t7;
	let opcodeset;
	let current;
	let mounted;
	let dispose;

	function program_prog_binding(value) {
		/*program_prog_binding*/ ctx[7](value);
	}

	let program_props = {};

	if (/*prog*/ ctx[1] !== void 0) {
		program_props.prog = /*prog*/ ctx[1];
	}

	program = new Program({ props: program_props });
	binding_callbacks.push(() => bind(program, 'prog', program_prog_binding));
	stack_1 = new Stack({ props: { stack: /*stack*/ ctx[0] } });
	heap_1 = new Heap({ props: { heap: /*heap*/ ctx[2] } });
	opcodeset = new OpcodeSet({});
	opcodeset.$on("op", /*doOp*/ ctx[5]);

	return {
		c() {
			div3 = element("div");
			create_component(program.$$.fragment);
			t0 = space();
			button0 = element("button");
			button0.textContent = "Reset";
			t2 = space();
			button1 = element("button");
			t3 = text("Next");
			t4 = space();
			div2 = element("div");
			div0 = element("div");
			create_component(stack_1.$$.fragment);
			t5 = space();
			div1 = element("div");
			create_component(heap_1.$$.fragment);
			t6 = space();
			br = element("br");
			t7 = space();
			create_component(opcodeset.$$.fragment);
			attr(button0, "class", "btn btn-warning svelte-mfwx6z");
			button1.disabled = /*isAnimating*/ ctx[3];
			attr(button1, "class", "btn btn-next svelte-mfwx6z");
			attr(div0, "class", "column svelte-mfwx6z");
			attr(div1, "class", "column svelte-mfwx6z");
			attr(div2, "class", "row svelte-mfwx6z");
		},
		m(target, anchor) {
			insert(target, div3, anchor);
			mount_component(program, div3, null);
			append(div3, t0);
			append(div3, button0);
			append(div3, t2);
			append(div3, button1);
			append(button1, t3);
			append(div3, t4);
			append(div3, div2);
			append(div2, div0);
			mount_component(stack_1, div0, null);
			append(div2, t5);
			append(div2, div1);
			mount_component(heap_1, div1, null);
			append(div3, t6);
			append(div3, br);
			append(div3, t7);
			mount_component(opcodeset, div3, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*parse*/ ctx[6]),
					listen(button1, "click", /*next*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const program_changes = {};

			if (!updating_prog && dirty & /*prog*/ 2) {
				updating_prog = true;
				program_changes.prog = /*prog*/ ctx[1];
				add_flush_callback(() => updating_prog = false);
			}

			program.$set(program_changes);

			if (!current || dirty & /*isAnimating*/ 8) {
				button1.disabled = /*isAnimating*/ ctx[3];
			}

			const stack_1_changes = {};
			if (dirty & /*stack*/ 1) stack_1_changes.stack = /*stack*/ ctx[0];
			stack_1.$set(stack_1_changes);
			const heap_1_changes = {};
			if (dirty & /*heap*/ 4) heap_1_changes.heap = /*heap*/ ctx[2];
			heap_1.$set(heap_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(program.$$.fragment, local);
			transition_in(stack_1.$$.fragment, local);
			transition_in(heap_1.$$.fragment, local);
			transition_in(opcodeset.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(program.$$.fragment, local);
			transition_out(stack_1.$$.fragment, local);
			transition_out(heap_1.$$.fragment, local);
			transition_out(opcodeset.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div3);
			destroy_component(program);
			destroy_component(stack_1);
			destroy_component(heap_1);
			destroy_component(opcodeset);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { stack = [] } = $$props;
	let { heap = [10, 20, 3, 45] } = $$props;
	let { prog = '4 D 3 5 + - =' } = $$props;

	// protect against race conditions during animations
	let isAnimating = false;

	const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
	let seq = [];

	const opMap = {
		push() {
			console.log('op: PUSH');
		},
		pop() {
			console.log('op: POP');
		},
		async equals() {
			const a = Number(stack.pop().value); // stack = stack
			const b = Number(stack.pop().value);
			$$invalidate(0, stack);
			await delay(500);
			await pushData(a === b);
		}, // stack = stack
		async add() {
			const a = Number(stack.pop().value); // stack = stack
			const b = Number(stack.pop().value);
			$$invalidate(0, stack);
			await delay(500);
			await pushData(a + b);
		}, // stack = stack
		async subtract() {
			const a = Number(stack.pop().value); // stack = stack
			const b = Number(stack.pop().value);
			$$invalidate(0, stack);
			await delay(500);
			await pushData(a - b);
		}, // stack = stack
		async dup() {
			const a = peekTosreg(); // stack = stack
			await pushData(a.value);
		}, // stack = stack
		
	};

	parse();

	// iterate stack if there is sth. to do
	async function next() {
		$$invalidate(3, isAnimating = true);
		const tosreg = peekTosreg();

		if (tosreg?.type === 'opcode') {
			// perform operation if there is one on top of the stack
			stack.pop();

			const op = opMap[tosreg.value];
			await op();

			// check for program exit state
			if (seq.length === 0 && stack.length === 1) {
				if (stack[0]) {
					console.log('SUCCESS!');
				} else {
					console.log('FAILED!');
				}
			}
		} else {
			// continue in the program otherwise
			if (seq.length > 0) {
				await push(seq.shift());
			}
		}

		$$invalidate(3, isAnimating = false);
	}

	// peeks the Top Of Stack REGister
	function peekTosreg() {
		if (stack.length === 0) return;
		return stack[stack.length - 1];
	}

	// user clicked on opcode, place opcode in prog sequence
	function doOp({ detail: opcode }) {
		const name = opcode.name;
		const op = opMap[name];

		if (!op) {
			return console.log('un-mapped operation:', name);
		}

		$$invalidate(1, prog = prog.trim().concat(' ', opcode.operation));
	}

	function parse() {
		$$invalidate(0, stack = []);
		seq = [];
		const instructions = prog.split(' ');

		for (const s of instructions) {
			const opcode = instructionSet.find(x => x.operation === s);

			// console.log('PARSE:', {opcode})
			if (opcode) {
				// op_code
				// console.log(`PROG: OP_${opcode.name}`)
				seq.push({ type: 'opcode', value: opcode.name });
			} else {
				// data
				// console.log(`PROG: > ${s}`)
				seq.push({
					type: 'data', // push(opcode.name)
					value: s
				});
			} // push(s)
		}

		console.log('program:', seq);
	}

	let elId = 0;

	async function push({ type, value }) {
		const element = { id: elId++, type, value };
		$$invalidate(0, stack = [...stack, element]);
		await delay(500);
	}

	function pushData(value) {
		push({ type: 'data', value });
	}

	function pop() {
		stack.splice(stack.length - 1, 1);
		$$invalidate(0, stack);
	}

	function program_prog_binding(value) {
		prog = value;
		$$invalidate(1, prog);
	}

	$$self.$$set = $$props => {
		if ('stack' in $$props) $$invalidate(0, stack = $$props.stack);
		if ('heap' in $$props) $$invalidate(2, heap = $$props.heap);
		if ('prog' in $$props) $$invalidate(1, prog = $$props.prog);
	};

	return [stack, prog, heap, isAnimating, next, doOp, parse, program_prog_binding];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { stack: 0, heap: 2, prog: 1 });
	}
}

export default App;